package uz.ferro.shop.document.view

import emotion.react.css
import mui.system.Box
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import react.dom.html.ReactHTML.span
import uz.ferro.shop.document.FormattedText
import uz.ferro.shop.document.TextSpan
import web.cssom.Color
import web.cssom.FontStyle
import web.cssom.integer

external interface FormattedTextViewProps : PropsWithSx {
    var formattedText: FormattedText
}

@Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")
val FormattedTextView = FC<FormattedTextViewProps> { props ->
    val items = props.formattedText.spans ?: listOf(TextSpan(text = props.formattedText.text.orEmpty()))
    Box {
        sx {
            fontWeight = props.sx?.fontWeight
            fontSize = props.sx?.fontSize
            color = props.sx?.color
            props.sx?.textAlign?.also { textAlign = it }
        }

        items.forEach { sp->
            span {
                css {
                    if (sp.isBold == true) {
                        fontWeight = integer(700)
                    }

                    if (sp.isItalic == true) {
                        fontStyle = FontStyle.italic
                    }

                    if (sp.color != null) {
                        color = sp.color as Color
                    }
                }
                +sp.text.orEmpty()
            }
        }
    }
}